// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/big-logo-grey-common.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFoundPage_not-found__B7kGZ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.NotFoundPage_content__i8xyq {
  text-align: center;
}

.NotFoundPage_title__17dfO {
  text-align: center;
  font-weight: 300 !important;
  font-size: 78px !important;
  color: #FFFFFF;
  margin: 0 !important;
  text-shadow: -1px 0 #8686FF, 0 1px #8686FF, 1px 0 #8686FF, 0 -1px #8686FF;
}

.NotFoundPage_subtitle__K6Hlb {
  font-weight: 500;
  font-size: 20px;
  color: #00007A;
  margin: 30px 0 25px 0;
}

.NotFoundPage_text__uJTDk {
  max-width: 300px;
  font-size: 16px;
  font-weight: 300;
}

.NotFoundPage_link__lPW2H a {
  color: inherit !important;
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/pages/NotFoundPage/NotFoundPage.module.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,yBCVM;EDWN,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AAkBF;;AAfA;EACE,kBAAA;AAkBF;;AAfA;EACE,kBAAA;EACA,2BAAA;EACA,0BAAA;EACA,cCzBM;ED0BN,oBAAA;EACA,yEACE;AAiBJ;;AAXA;EACE,gBAAA;EACA,eAAA;EACA,cC7BM;ED8BN,qBAAA;AAcF;;AAXA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AAcF;;AAXA;EACE,yBAAA;EACA,0BAAA;AAcF","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n@use 'components/reporting/styles/sizes.scss';\n\n.not-found {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  width: 100%;\n  height: 100vh;\n  background-color: colors.$light;\n  background-image: url(../../../../assets/big-logo-grey-common.svg);\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.content {\n  text-align: center;\n}\n\n.title {\n  text-align: center;\n  font-weight: 300!important;\n  font-size: 78px!important;\n  color: colors.$light;\n  margin: 0 !important;\n  text-shadow:\n    -1px 0 colors.$blue4,\n    0 1px colors.$blue4,\n    1px 0 colors.$blue4,\n    0 -1px colors.$blue4;\n}\n\n.subtitle {\n  font-weight: 500;\n  font-size: 20px;\n  color: colors.$blue1;\n  margin: 30px 0 25px 0;\n}\n\n.text{\n  max-width: 300px;\n  font-size: 16px;\n  font-weight: 300;\n}\n\n.link a{\n  color: inherit!important;\n  text-decoration: underline;\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`,
	"not-found": `NotFoundPage_not-found__B7kGZ`,
	"content": `NotFoundPage_content__i8xyq`,
	"title": `NotFoundPage_title__17dfO`,
	"subtitle": `NotFoundPage_subtitle__K6Hlb`,
	"text": `NotFoundPage_text__uJTDk`,
	"link": `NotFoundPage_link__lPW2H`
};
export default ___CSS_LOADER_EXPORT___;
